import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  ViewOfferQueryQuery,
  ViewOfferQueryQueryVariables
} from "../../../schemaTypes";

export const viewOfferQuery = gql`
  query ViewOfferQuery($id: String!) {
    viewOffer(id: $id) {
      id
      title
      description
      offerType
      startDate
      endDate
      offerTOR
      status
      category {
        id
        name
        imgSrc
      }
      community{
        id
        name
        alias
      }
      usageLimitPerUser
      totalUsageLimit
      location{
        id
        city
        country
      }
      bannerUrl
      discountType
      discountValue
      partnerVoucher
      referralUrl
      amount
      redemptions
      shareCount
      offerPointsDeduction {
        id
        offerId
        point
        createdAt
        updatedAt
      }
      createdBy{
        id
        admin {
          shortId
          merchantProfile {
            id
            companyName
            logoUrl
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export interface WithViewOffer {
  offer: ViewOfferQueryQuery['viewOffer'] | null;
  loading: boolean;
}

interface Props {
  offerId: string;
  children: (data: WithViewOffer) => React.ReactElement | null;
}

export const ViewOffer: React.FC<Props> = ({ offerId, children }) => {
  const { data, loading } = useQuery<ViewOfferQueryQuery, ViewOfferQueryQueryVariables>(viewOfferQuery, {
    variables: { id: offerId }
  });

  let offer: ViewOfferQueryQuery['viewOffer'] | null = null;
  if (data && data.viewOffer) {
    offer = data.viewOffer;
  }

  return children({
    offer,
    loading
  });
};